import { queryOptions } from '@tanstack/react-query';
import { apiList } from '@/lib/api-client';
import type { Preticket, PreticketStatus } from '@erp/shared';

/**
 * Contador do badge da aba "Pré-tickets" dentro de /tickets: `limit=1` porque
 * só o X-Total-Items importa. Mesmo prefixo de queryKey das listas ⇒ as
 * invalidações de aceitar/descartar (['erp','pretickets']) já o derrubam.
 */
export function pendingPreticketsCountQuery() {
  return queryOptions({
    queryKey: ['erp', 'pretickets', 'count', 'pending'] as const,
    queryFn: async ({ signal }) => {
      const res = await apiList<Preticket>('/pretickets', {
        query: { status: 'pending', limit: 1 },
        signal,
      });
      if (res.error) throw res.error;
      return res.data.total;
    },
    staleTime: 30_000,
  });
}

/** GET /pretickets?status= — total via X-Total-Items (contador das abas). */
export function preticketsListOptions(status: PreticketStatus) {
  return queryOptions({
    queryKey: ['erp', 'pretickets', 'list', { status }] as const,
    queryFn: async ({ signal }) => {
      const res = await apiList<Preticket>('/pretickets', {
        query: { status, limit: 100 },
        signal,
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
